import { store } from '../store/store'

export const getStore = () => store
